/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientDetailsResource
 */
export interface ClientDetailsResource {
    /**
     * 
     * @type {string}
     * @memberof ClientDetailsResource
     */
    identityId: string;
    /**
     * 
     * @type {string}
     * @memberof ClientDetailsResource
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ClientDetailsResource
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ClientDetailsResource
     */
    photoUrl?: string;
}

/**
 * Check if a given object implements the ClientDetailsResource interface.
 */
export function instanceOfClientDetailsResource(value: object): value is ClientDetailsResource {
    if (!('identityId' in value) || value['identityId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function ClientDetailsResourceFromJSON(json: any): ClientDetailsResource {
    return ClientDetailsResourceFromJSONTyped(json, false);
}

export function ClientDetailsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientDetailsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'identityId': json['identityId'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'photoUrl': json['photoUrl'] == null ? undefined : json['photoUrl'],
    };
}

export function ClientDetailsResourceToJSON(value?: ClientDetailsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'identityId': value['identityId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'photoUrl': value['photoUrl'],
    };
}

